import React from "react";

const STATUS_STYLES = {
  SUCCESS: ["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  SHIPPED: ["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  DELIVERED: ["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  CONFIRMED: ["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  COMPLETED: ["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  PAID: ["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  PROCESSING: ["#1d4ed8", "rgba(59,130,246,0.12)", "rgba(59,130,246,0.35)"],
  PENDING: ["#a16207", "rgba(234,179,8,0.12)", "rgba(234,179,8,0.35)"],
  CANCELLED: ["#b91c1c", "rgba(239,68,68,0.12)", "rgba(239,68,68,0.35)"],
  FAILED: ["#b91c1c", "rgba(239,68,68,0.12)", "rgba(239,68,68,0.35)"],
  REFUNDED: ["#6b21a8", "rgba(147,51,234,0.12)", "rgba(147,51,234,0.35)"],
  PARTIALLY_DELIVERED: ["#0f766e", "rgba(20,184,166,0.12)", "rgba(20,184,166,0.35)"],
  CATALOGUE: ["#0f766e", "rgba(20,184,166,0.12)", "rgba(20,184,166,0.35)"],
  PRODUCT: ["#0f766e", "rgba(20,184,166,0.12)", "rgba(20,184,166,0.35)"],
  ITEMS: ["#7c3aed", "rgba(124,58,237,0.12)", "rgba(124,58,237,0.35)"],
  RETAIL:["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  ACTIVE: ["#15803d", "rgba(34,197,94,0.12)", "rgba(34,197,94,0.35)"],
  INACTIVE: ["#b91c1c", "rgba(239,68,68,0.12)", "rgba(239,68,68,0.35)"],
};

const StatusBadge = ({ status, count = 0 }) => {
  if (!status) return null;

  const normalizedStatus = status.toUpperCase();

  const [color, bg, border] =
    STATUS_STYLES[normalizedStatus] || [
      "#374151",
      "rgba(107,114,128,0.12)",
      "rgba(107,114,128,0.35)",
    ];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "5px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        letterSpacing: "0.4px",
        color: color,
        backgroundColor: bg,
        border: `1px solid ${border}`,
      }}
    >
      {normalizedStatus.replaceAll("_", " ")}

      {(normalizedStatus === "ITEMS" || count > 0) && (
        <span
          style={{
            background: color,
            color: "#fff",
            borderRadius: "10px",
            padding: "2px 6px",
            fontSize: "10px",
          }}
        >
          {count}
        </span>
      )}
    </span>
  );
};
export default StatusBadge;
